import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, Icon, Chip } from '@arnsbogroup/react-voicearchive'
import { FormattedTime, FormattedDate, FormattedRelativeTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'

export default ({ order }) => {
  const { formatTime, formatDate } = useIntl()
  const [state, setState] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`/rest/v2/project?search[orderId]=${order.uid}`)
      .then((response) => response.json())
      .then(({ data: projects }) => projects?.[0]?.hash_id)
      .then((projectHashId) => {
        if (projectHashId) {
          return fetch(`/rest/v2/project/${projectHashId}`)
            .then((response) => response.json())
            .then(({ meta, data: project }) => setState({ project, meta }))
        }
      })
      .finally(() => setLoading(false))
      .catch((err) => {
        window.alert(err)
        console.error(err)
      })
  }, [])

  const date = state.project ? new Date(state.project.updatedAt) : null;

  if (!loading && !state.project) {
    return (
      <Card className="flex items-center justify-center">
        <p className="text-gray-500">No project found</p>
      </Card>
    )
  }

  return (
    <Card className="h-full">
      <h2 className="sr-only">Project</h2>
      <div className="flex flex-col h-full">
        <div className="grow">
          <dl className="flex flex-wrap">
            <div className="flex-auto p-4">
              <dt className="text-sm font-semibold leading-6 text-gray-900">Project</dt>
              <dd className="mt-1 text-base font-semibold leading-6 text-gray-900">
                { loading ? (
                  <span>-</span>
                ) : (
                  <span>{ state.meta?.messages['containers.ProjectPage.title'] }</span>
                ) }
              </dd>
            </div>
            <div className="flex-none self-end p-4">
              <dt className="sr-only">Status</dt>
              <dd className="inline-flex items-center">
                <Chip state="success">{ loading ? <Loader /> : state.project?.stage }</Chip>
              </dd>
            </div>

            <a
              href={state.meta?.href.public}
              target="_blank"
              className="w-full border-t border-gray-200 p-4 font-mono text-sm whitespace-pre-wrap break-all text-primary hover:text-primary-darker"
            >
              { state.meta?.href.public }
            </a>

            { [
              ['Initiated by', ['fas', 'user'], state.project?.initiatedBy?.replace(/^\w/, c => c.toUpperCase())],
              [
                'Last changed',
                ['fas', 'clock'],
                <time title={formatDate(date) + ' ' + formatTime(date)}>
                  <FormattedDate value={date} /> <FormattedTime value={date} />
                </time>
              ],
            ].map(([label, icon, value]) => (
              <div className="flex w-full flex-none gap-x-4 border-t border-gray-200 px-4 py-2 items-center">
                <dt className="flex-none flex space-x-2 w-1/2 items-center">
                  <Icon icon={icon} className="text-sm text-gray-400" aria-hidden="true" />
                  <span className="font-medium text-sm text-gray-600">{ label }</span>
                </dt>
                <dd className="text-sm font-medium leading-6 text-gray-900 w-1/2 text-right">
                  { loading ? <Loader /> : value }
                </dd>
              </div>
            )) }
          </dl>
        </div>

        <div className="border-t border-gray-200 p-4">
          <a href={state.meta?.href.public} target="_blank" className="text-sm font-semibold leading-6 text-gray-900">
            Open project <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </Card>
  )
}

const Loader = () => (
  <Icon className="animate-spin" icon={['fas', 'spinner']} />
)
